import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  LinearProgress,
  Card,
  CardHeader,
  CardContent,
  Alert,
  IconButton,
  // InputAdornment,
  // ClickAwayListener,
  // Popper,
  // Paper,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid2';
// import { DatePicker } from '@mui/x-date-pickers';
import useAfasData from '../hooks/useAfasData';
import OfferteRegels from './OfferteRegels';
import OfferteTotals from './OfferteTotals';
import DatePicker from './DatePicker';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import dayjs from 'dayjs';

// // Mock data fetching functions
// const fetchOptions = (endpoint) => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve([
//         { label: 'Option 1', value: 'option1' },
//         { label: 'Option 2', value: 'option2' },
//         { label: 'Option 3', value: 'option3' },
//       ]);
//     }, 1000); // Simulate API delay
//   });
// };

// const CustomDatePicker = ({ label, value, onChange, fullWidth = true, sx = {} }) => {
//   const [open, setOpen] = useState(false);
//   const anchorRef = useRef(null);

//   const handleToggle = () => {
//     setOpen((prevOpen) => !prevOpen);
//   };

//   const handleClose = (event) => {
//     if (anchorRef.current && anchorRef.current.contains(event.target)) {
//       return;
//     }
//     setOpen(false);
//   };

//   const handleDateChange = (newDate) => {
//     onChange(newDate);
//     setOpen(false);
//   };

//   return (
//     <>
//       <TextField
//         label={label}
//         value={value ? dayjs(value).format('D MMMM YYYY') : ''}
//         onClick={handleToggle}
//         fullWidth={fullWidth}
//         sx={sx}
//         inputRef={anchorRef}
//         InputProps={{
//           readOnly: true,
//           endAdornment: (
//             <InputAdornment position="end">
//               <IconButton
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleToggle();
//                 }}
//                 edge="end"
//               >
//                 <CalendarTodayIcon color="secondary" sx={{ fontSize: 16 }} />
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//       />

//       <Popper
//         open={open}
//         anchorEl={anchorRef.current}
//         placement="bottom-start"
//         disablePortal
//         style={{ zIndex: 1300 }}
//       >
//         <ClickAwayListener onClickAway={handleClose}>
//           <Paper elevation={8}>
//             <DateCalendar date={value || null} onChange={handleDateChange} disableAutoFocus={true} />
//           </Paper>
//         </ClickAwayListener>
//       </Popper>
//     </>
//   );
// };

function OfferteForm(debtor) {
  console.log({ debtor });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const forecastId = searchParams.get('FoId');
  console.log(forecastId);
  const [rows, setRows] = useState([
    {
      type: '',
      code: '',
      unit: '',
      description: '',
      amount: 0,
      billable: true,
      remarks: '',
      pricePerUnit: 0,
      total: 0,
    },
  ]);
  const [openAlert, setOpenAlert] = useState(false);

  const debtorId = debtor ? debtor.debtor.id : null;

  console.log({ debtorId });

  const {
    data: contactData = [],
    isLoading: contactDataLoading,
    errorMessage: contactDataErrorMessage,
  } = useAfasData('/contacts', { debtorId }, { enabled: !!debtor.debtor?.id });

  console.log({ contactData });

  const {
    data: documenten = [],
    isLoading: documentenLoading,
    errorMessage: documentenErrorMessage,
  } = useAfasData('/documents', { debtorId }, { enabled: !!debtor.debtor?.id });

  console.log({ documenten });

  const {
    data: tabelData = [],
    isLoading: tabelDataLoading,
    errorMessage: tabelDataErrorMessage,
  } = useAfasData('/tables');

  console.log({ tabelData });

  const {
    data: locatieVSL = [],
    isLoading: locatieVSLLoading,
    errorMessage: locatieVSLErrorMessage,
  } = useAfasData('/vsllocations', { debtorId });

  console.log({ locatieVSL });

  const {
    data: afleveradres = [],
    isLoading: afleveradresLoading,
    errorMessage: afleveradresErrorMessage,
  } = useAfasData('/locations', { debtorId });

  console.log({ afleveradres });

  const {
    data: verantwoordelijken = [],
    isLoading: verantwoordelijkenLoading,
    errorMessage: verantwoordelijkenErrorMessage,
  } = useAfasData('/employees');

  console.log({ verantwoordelijken });
  // const verantwoordelijken = [];

  // const {
  //   data: verantwoordelijken = [],
  //   isLoading: verantwoordelijkenOptionsLoading,
  //   errorMessage: verantwoordelijkenOptionsErrorMessage,
  // } = fetchOptions('/verantwoordelijken');

  // const {
  //   data: transportOptions = [],
  //   isLoading: transportOptionsLoading,
  //   errorMessage: transportOptionsErrorMessage,
  // } = fetchOptions('/transport');

  // const {
  //   data: locatieVSL = [],
  //   isLoading: locatieVSLLoading,
  //   errorMessage: locatieVSLErrorMessage,
  // } = fetchOptions('/locatieVSL');

  // const {
  //   data: taalCertificaat = [],
  //   isLoading: taalCertificaatLoading,
  //   errorMessage: taalCertificaatErrorMessage,
  // } = fetchOptions('/taalCertificaat');

  // const {
  //   data: incoterms = [],
  //   isLoading: incotermsLoading,
  //   errorMessage: incotermsErrorMessage,
  // } = fetchOptions('/incoterms');

  const [formValues, setFormValues] = useState({
    onderwerp: '',
    contactpersoon: '',
    document: '',
    bestandnaam: '',
    verantwoordelijke: '',
    offertedatum: null,
    kalibratiedatum: null,
    doorlooptijd: '',
    afleveradres: '',
    transportNaarVSL: '',
    transportVanVSL: '',
    incoterms: '',
    locatieVSL: '',
    taalCertificaat: '',
    certificaatAdres: '',
    emailCertificaat: '',
  });

  const [dropdownOptions, setDropdownOptions] = useState({
    contactData: [],
    documenten: [],
    verantwoordelijken: [],
    transportOptions: [],
    locatieVSL: [],
    afleveradres: [],
    taalCertificaat: [],
    certificaatadres: [],
    incoterms: [],
  });

  // Check for API errors and update the errors state
  useEffect(() => {
    if (
      contactDataErrorMessage ||
      documentenErrorMessage ||
      tabelDataErrorMessage ||
      verantwoordelijkenErrorMessage ||
      // transportOptionsErrorMessage
      afleveradresErrorMessage ||
      locatieVSLErrorMessage
      // taalCertificaatErrorMessage ||
      // incotermsErrorMessage
    ) {
      setOpenAlert(true);
    }
  }, [
    contactDataErrorMessage,
    documentenErrorMessage,
    tabelDataErrorMessage,
    verantwoordelijkenErrorMessage,
    // transportOptionsErrorMessage,
    afleveradresLoading,
    locatieVSLErrorMessage,
    afleveradresErrorMessage,
    // taalCertificaatErrorMessage,
    // incotermsErrorMessage,
  ]);

  // Update dropdown options once all data is fetched
  useEffect(() => {
    if (
      !contactDataLoading &&
      !documentenLoading &&
      !tabelDataLoading &&
      !verantwoordelijkenLoading &&
      !afleveradresLoading &&
      !locatieVSLLoading
      // !taalCertificaatLoading &&
      // !incotermsLoading
    ) {
      const locaties = tabelData.filter((td) => td.Omschrijving === 'Transport VSL locatie');
      console.log({ locaties });
      const incos = tabelData.filter((td) => td.Omschrijving === 'incoterms');
      const talen = tabelData.filter((td) => td.Omschrijving === 'Taal certificaat');

      setDropdownOptions({
        contactData,
        documenten,
        verantwoordelijken,
        transportOptions: locaties,
        locatieVSL: locatieVSL,
        afleveradres: afleveradres,
        certificaatadres: afleveradres,
        taalCertificaat: talen,
        incoterms: incos,
      });
    }
  }, [
    contactData,
    documenten,
    verantwoordelijken,
    // transportOptions,
    locatieVSL,
    afleveradres,
    // taalCertificaat,
    // incoterms,
    documentenLoading,
    verantwoordelijkenLoading,
    // transportOptionsLoading,
    locatieVSLLoading,
    afleveradresLoading,
    // taalCertificaatLoading,
    // incotermsLoading,
    contactDataLoading,
    tabelDataLoading,
    tabelData,
  ]);

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };
  return (
    <Box my={6} sx={{ scrollBehavior: 'auto' }}>
      <Card>
        <CardHeader title="Stap 2. Offerte gegevens" slotProps={{ title: { variant: 'h2' } }} />
        <CardContent>
          {contactDataLoading && !openAlert && <LinearProgress mt={2} />}
          {openAlert && (
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  onClick={() => {
                    setOpenAlert(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              <strong>Er zijn fouten opgetreden bij het ophalen van gegevens:</strong>
            </Alert>
          )}
          <form>
            <Grid container spacing={3}>
              {/* Left Column */}
              <Grid size={6}>
                {/* <FormControl fullWidth sx={{ mt: 2 }}> */}
                <TextField
                  fullWidth
                  label="Onderwerp"
                  name="onderwerp"
                  value={formValues.onderwerp}
                  onChange={handleChange}
                  sx={{ mt: 2 }}
                  autoFocus={false}
                />
                {/* </FormControl> */}
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Contactpersoon</InputLabel>
                  <Select
                    name="contactpersoon"
                    value={formValues.contactData}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.contactData.map((option) => (
                      <MenuItem key={option.Contact} value={option.Contact}>
                        {option.Naam}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Document</InputLabel>
                  <Select
                    name="document"
                    value={formValues.document}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.documenten.map((option) => (
                      <MenuItem key={option.Omschrijving} value={option.Omschrijving}>
                        {option.Omschrijving}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  fullWidth
                  label="Bestandsnaam document"
                  name="bestandnaam"
                  value={formValues.bestandnaam}
                  onChange={handleChange}
                  sx={{ mt: 2 }}
                  autoFocus={false}
                />
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Verantwoordelijke</InputLabel>
                  <Select
                    name="verantwoordelijke"
                    value={formValues.verantwoordelijke}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.verantwoordelijken.map((option) => (
                      <MenuItem key={option.Naam} value={option.Medewerker}>
                        {option.Naam}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <DatePicker
                  label="Offertedatum"
                  dateValue={formValues.offertedatum}
                  setDateValue={(newDate) => setFormValues((prev) => ({ ...prev, offertedatum: newDate }))}
                  debtorSelected={debtorId} // pass `null` if you don't use this logic
                  fullWidth={true}
                />
                <DatePicker
                  label="Kalibratiedatum"
                  dateValue={formValues.kalibratiedatum}
                  setDateValue={(newDate) => setFormValues((prev) => ({ ...prev, kalibratiedatum: newDate }))}
                  debtorSelected={debtorId} // pass `null` if you don't use this logic
                />

                {/* <DatePicker
                  label="Offertedatum"
                  value={formValues.offertedatum}
                  onChange={(newValue) => setFormValues({ ...formValues, offertedatum: newValue })}
                  slotProps={{
                    textField: { fullWidth: true, sx: { mt: 2 } },
                  }}
                  PopperProps={{
                    disablePortal: true,
                  }}
                />

                <DatePicker
                  label="Kalibratiedatum"
                  value={formValues.kalibratiedatum}
                  onChange={(newValue) => setFormValues({ ...formValues, kalibratiedatum: newValue })}
                  disableAutoFocus
                  slotProps={{
                    textField: { fullWidth: true, sx: { mt: 2 } },
                  }}
                  PopperProps={{
                    disablePortal: true,
                  }}
                /> */}

                <TextField
                  fullWidth
                  label="Doorlooptijd"
                  name="doorlooptijd"
                  value={formValues.doorlooptijd}
                  onChange={handleChange}
                  sx={{ mt: 2 }}
                  autoFocus={false}
                />
              </Grid>

              {/* Right Column */}
              <Grid size={6}>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Afleveradres bij klant</InputLabel>
                  <Select
                    name="afleveradres"
                    value={formValues.afleveradres}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.afleveradres.map((option) => (
                      <MenuItem key={option.Adres_Id} value={option.Adres_Id}>
                        {option.Adresvoorbeeld}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Transport naar VSL</InputLabel>
                  <Select
                    name="transportNaarVSL"
                    value={formValues.transportNaarVSL}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.transportOptions.map((option) => (
                      <MenuItem key={option.Code} value={option.Code}>
                        {option.Omschrijving_2}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Transport van VSL</InputLabel>
                  <Select
                    name="transportVanVSL"
                    value={formValues.transportVanVSL}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.transportOptions.map((option) => (
                      <MenuItem key={option.Code} value={option.Code}>
                        {option.Omschrijving_2}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Incoterms</InputLabel>
                  <Select
                    name="incoterms"
                    value={formValues.incoterms}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.incoterms.map((option) => (
                      <MenuItem key={option.Code_2} value={option.Code}>
                        {option.Omschrijving_2}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Locatie VSL</InputLabel>
                  <Select
                    name="locatieVSL"
                    value={formValues.locatieVSL}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.locatieVSL.map((option) => (
                      <MenuItem key={option.Adres_Id} value={option.Adres_Id}>
                        {option.Adresvoorbeeld}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Taal certificaat</InputLabel>
                  <Select
                    name="taalCertificaat"
                    value={formValues.taalCertificaat}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.taalCertificaat.map((option) => (
                      <MenuItem key={option.Code_2} value={option.Code}>
                        {option.Omschrijving_2}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>Certificaatadres</InputLabel>
                  <Select
                    name="certificaatAdres"
                    value={formValues.certificaatAdres}
                    onChange={handleChange}
                    MenuProps={{ disablePortal: true }}
                    autoFocus={false}
                  >
                    {dropdownOptions.certificaatadres.map((option) => (
                      <MenuItem key={option.Adres_Id} value={option.Adres_Id}>
                        {option.Adresvoorbeeld}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  fullWidth
                  label="E-mail adres certificaat"
                  name="emailCertificaat"
                  value={formValues.emailCertificaat}
                  onChange={handleChange}
                  sx={{ mt: 2 }}
                  autoFocus={false}
                />
              </Grid>
            </Grid>
            <OfferteRegels rows={rows} setRows={setRows} debtorId={debtorId} />
            <OfferteTotals rows={rows} formValues={formValues} debtorId={debtorId} forecastId={forecastId} />
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}

export default OfferteForm;
